import Vue from 'vue';
import { getProfile } from '../../../services/personnelService/qrCodeService';

  // initial state
  // state 必為模組區域變數，取時需 store.state.auth.user
  // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
  // 區域使用時值需加上 name
  const state = {
    data: null
  };

  // getters
  const getters = {};

  // actions
  const actions = {
    // 取得CA Profile
    async getProfileHandler({ commit }) {
      const data = await getProfile();
      commit('setData', data.data);
    }
  };

  // mutations
  const mutations = {
    setData(state, data) {
      Vue.set(state, 'data', data.personnel);
    }
  };

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
